import "preact/debug";
import { useState, useEffect } from "preact/hooks";
import { render } from "preact";
import headerStyles from "./header.module.css";
import hamburgerStyles from "./hamburger.module.css";
import mobileStyles from "./mobile-menu.module.css";
import desktopStyles from "./desktop-menu.module.css";
import { MobileMenu } from "./mobile-menu";
import { Chevron } from "./chevron";
import { LinkContent } from "./linkContent";
import { Categories } from "./categories";
import { NewsLetter } from "./newsletter";
import { showExpandButton } from "./helpers";
import {SearchBar} from "./searchBar";


function MegaNav({ link }) {
  return (
    <div
      class={`${desktopStyles["mega-menu"]} ${
        link.isOpen ? desktopStyles["mega-menu--active"] : ""
      }`}
    >
      <div class="container">
        <div class={desktopStyles["mega-menu__container"]}>
          <LinkContent link={link} />
          <Categories link={link} />
          <NewsLetter link={link} />
        </div>
      </div>
    </div>
  );
}

function DesktopMenu({ meganav }) {
  const [internalMeganav, setInternalMeganav] = useState(meganav);

  function closeAllMenus() {
    setInternalMeganav(
      internalMeganav.map((menu) => {
        return {
          ...menu,
          isOpen: false,
        };
      })
    );
  }

  function shouldMenuClose(node, targetId) {
    const parentNode = node.parentNode;
    if (parentNode?.nodeName === "BODY" || node.nodeName === "BODY") {
      return true;
    }
    if (parentNode?.id === targetId) {
      return false;
    }
    return shouldMenuClose(parentNode, targetId);
  }

  useEffect(() => {
    // Close menus on esc press
    document.addEventListener("keydown", function (event) {
      if (event.key == "Escape") {
        closeAllMenus();
      }
    });

    // close when clicked outside menu
    document.body.addEventListener("mouseup", function (event) {
      const result = shouldMenuClose(event.target, "desktop-nav");
      if (result) {
        closeAllMenus();
      }
    });
  }, []);

  function open(id, state) {
    setInternalMeganav(
      internalMeganav.map((menu) => {
        if (menu.id === id) {
          return {
            ...menu,
            isOpen: state,
          };
        }
        return {
          ...menu,
          isOpen: false,
        };
      })
    );
  }

  return (
    <div class={`${desktopStyles["header-nav"]}`} id="desktop-nav">
      <nav>
        <ul class={desktopStyles["header-nav__links"]}>
          {internalMeganav.map((link) => (
            <li key={link.id}>
              <div>
                {!showExpandButton(link) && (
                  <div class={desktopStyles["link-container"]}>
                    <a href={link.url} class={desktopStyles["link"]}>
                      {link.name}
                    </a>
                  </div>
                )}
                {showExpandButton(link) && (
                  <div
                    class={`${desktopStyles["link-container"]} ${
                      link.isOpen ? desktopStyles["link-container--active"] : ""
                    }`}
                  >
                    <a href={link.url} class={`${desktopStyles["link"]}`}>
                      {link.name}
                    </a>
                    <button
                      type="button"
                      onClick={() => open(link.id, !link.isOpen)}
                      class={desktopStyles["chevron"]}
                    >
                      <Chevron css={{ transform: "none" }} />
                    </button>
                  </div>
                )}
              </div>

              {link.hasMegaMenu && <MegaNav link={link} />}

              {!link.hasMegaMenu && link.children.length > 0 && (
                <div
                  class={`${desktopStyles["menu"]} ${
                    link.isOpen ? desktopStyles["menu--active"] : ""
                  }`}
                >
                  <ul>
                    {link.children.map((child) => (
                      <li class={mobileStyles["link"]}>
                        <a href={child.url}>{child.name}</a>
                      </li>
                    ))}
                  </ul>
                </div>
              )}
            </li>
          ))}
        </ul>
      </nav>
    </div>
  );
}

function App({ siteHeader }) {
  const [showMobileMenu, setShowMobileMenu] = useState(false);

  return (
    <header class={headerStyles["header"]}>
      <div>
        <div class={`${headerStyles["header__container"]}`}>
          <a href="/" class={headerStyles["header__logo"]}>
            <img src={siteHeader.logoUrl} alt="fespa logo" />
          </a>
          <button
            class={`${hamburgerStyles["hamburger"]} ${
              headerStyles["header__hamburger"]
            } ${showMobileMenu ? hamburgerStyles["hamburger--active"] : ""}`}
            onClick={() => setShowMobileMenu(!showMobileMenu)}
          >
            <span class={`${hamburgerStyles["hamburger-toggle"]}`}>
              <span></span>
            </span>
            <span class="visually-hidden">{globalThis.translations.toggleMenu || "Toggle Menu"}</span>
          </button>

          <div class={headerStyles["header__search"]}>
            <SearchBar showMobileMenu={showMobileMenu} instanceId="headerSearch" />
          </div>

          <div class={headerStyles["header__mobile-menu"]}>
            <MobileMenu
              meganav={siteHeader.meganav}
              showMobileMenu={showMobileMenu}
            />
          </div>
          <div class={headerStyles["header__desktop-menu"]}>
            <DesktopMenu meganav={siteHeader.meganav} />
          </div>
        </div>
      </div>
    </header>
  );
}

const megaNavNode = document.getElementById("mega-nav");

if (megaNavNode) {
  render(<App siteHeader={globalThis.siteHeader} />, megaNavNode);
}
